import { Select } from 'antd';
import { FormattedMessage } from 'react-intl';

function MultipleSelectUsers({ users, selectedUsers, setSelectedUsers, isLoading = false }) {
	const { Option } = Select;

	return (
		<Select
			style={{ width: '100%', marginBottom: -50 }}
			name="notification_users"
			size="default"
			className="input-forms"
			placeholder={<FormattedMessage id="placeholder_users" />}
			mode="multiple"
			disabled={isLoading}
			maxTagCount={2}
			maxTagPlaceholder={(omittedValues) => `+ ${omittedValues.length}`}
			value={selectedUsers.map((user) => user.id)}
			onChange={(values) => {
				if (values.includes(0)) {
					setSelectedUsers([{ id: 0, fullName: 'User with ID 0' }]);
				} else {
					const selectedUsersWithFullName = values?.map((userId) => {
						const user = users.find((u) => u.id === userId);
						return { id: userId, fullName: user?.fullName || '' };
					});
					setSelectedUsers(selectedUsersWithFullName);
				}
			}}
			required
			showSearch
			optionFilterProp="children"
			filterOption={(input, option) =>
				option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
			}
		>
			{users.map((user) => (
				<Option key={user.id} value={user.id}>
					{user?.fullName || ''}
				</Option>
			))}
		</Select>
	);
}

export default MultipleSelectUsers;
